<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
      <div class="pl-12 pr-12 col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs
          class="pl-0 pb-10"
          :items="breadcrumbs"
          divider=">"
        ></v-breadcrumbs>
        <v-row>
          <!-- edit -->
          <v-dialog v-model="dialogEdit" persistent max-width="50%" scrollable>
            <v-card class="text-center">
              <v-form ref="form_update" v-model="validUpdate" lazy-validation>
                <v-card-text style="max-height: 70vh; overflow-y: auto;">
                  <v-container>
                    <v-col class="text-right">
                      <v-btn small color="#E0E0E0" @click="dialogEdit = false">
                        <v-icon color="#173053">mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                    <v-row justify="center">
                      <v-col cols="12" class="text-center">
                        <v-img
                          aspect-ratio="6"
                          contain
                          height="200"
                          :src="formUpdate.logoPreview"
                        ></v-img>
                        <br />
                        <v-file-input
                          required
                          counter
                          show-size
                          accept="image/png, image/jpeg, image/bmp"
                          prepend-icon="mdi-camera"
                          label="โลโก้ร้าน"
                          @change="selectImgShop"
                          v-model="filesShop"
                        ></v-file-input>
                      </v-col>
                    </v-row>
                    <v-row justify="center">
                      <v-col cols="6" class="text-center">
                        <v-img
                          aspect-ratio="6"
                          height="200"
                          contain
                          :src="formUpdate.flexPicHomePagePreview"
                        ></v-img>
                        <br />
                        <v-file-input
                          required
                          counter
                          show-size
                          accept="image/png, image/jpeg, image/bmp"
                          prepend-icon="mdi-camera"
                          label="รูปต้อนรับหลังเปิดบัตรสมาชิก"
                          @change="selectImgHomePage"
                          v-model="flexPicHomePage"
                        ></v-file-input>
                      </v-col>
                      <v-col cols="6" class="text-center">
                        <v-img
                          aspect-ratio="6"
                          height="200"
                          contain
                          :src="formUpdate.flexPicMembercardPagePreview"
                        ></v-img>
                        <br />
                        <v-file-input
                          required
                          counter
                          show-size
                          accept="image/png, image/jpeg, image/bmp"
                          prepend-icon="mdi-camera"
                          label="รูปต้อนรับหลังเปิดบัตรสมาชิกMember Card"
                          @change="selectImgMemberCard"
                          v-model="flexPicMembercardPage"
                        ></v-file-input>
                      </v-col>
                    </v-row>
                    <v-row justify="center">
                      <v-col cols="5" class="text-center">
                        <v-img
                          class="v_text"
                          :src="require('@/assets/GroupEditTitle.svg')"
                        ></v-img>
                      </v-col>
                    </v-row>
                    <v-row justify="center">
                      <v-col cols="10" class="text-center">
                        <v-img
                          aspect-ratio="6"
                          contain
                          :src="formUpdate.pictureUrlPreview"
                        ></v-img>
                        <br />
                        <v-file-input
                          required
                          counter
                          show-size
                          accept="image/png, image/jpeg, image/bmp"
                          prepend-icon="mdi-camera"
                          label="Image"
                          @change="selectImgUpdate()"
                          v-model="filesUpdate"
                        ></v-file-input>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6">
                        <v-row style="height: 65px">
                          <v-text-field
                            placeholder="ชื่อร้าน"
                            label="ชื่อร้าน"
                            outlined
                            dense
                            v-model="formUpdate.name"
                            :rules="[rules.required]"
                            required
                          ></v-text-field>
                        </v-row>
                      </v-col>
                      <v-col cols="6">
                        <v-row style="height: 65px">
                          <v-text-field
                            placeholder="เบอร์โทรศัพท์"
                            label="เบอร์โทรศัพท์"
                            outlined
                            dense
                            v-model="formUpdate.contactTel"
                            :rules="[rules.required, rules.numberRules]"
                            :counter="10"
                            maxlength="10"
                            required
                          ></v-text-field>
                        </v-row>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="6">
                        <v-row style="height: 65px">
                          <v-text-field
                            placeholder="E-mail"
                            label="E-mail"
                            outlined
                            dense
                            v-model="formUpdate.Email"
                            type="email"
                          ></v-text-field>
                        </v-row>
                      </v-col>
                      <v-col cols="6">
                        <v-row style="height: 65px">
                          <v-text-field
                            placeholder="Website"
                            label="Website"
                            outlined
                            dense
                            v-model="formUpdate.WebsiteShop"
                          ></v-text-field>
                        </v-row>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="6">
                        <v-row style="height: 65px">
                          <v-text-field
                            placeholder="Facebook"
                            label="Facebook"
                            outlined
                            dense
                            v-model="formUpdate.FacebookShop"
                          ></v-text-field>
                        </v-row>
                      </v-col>
                      <v-col cols="6">
                        <v-row style="height: 65px">
                          <v-text-field
                            placeholder="LINE"
                            label="LINE"
                            outlined
                            dense
                            v-model="formUpdate.LineShop"
                          ></v-text-field>
                        </v-row>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="6">
                        <v-row style="height: 65px">
                          <v-text-field
                            placeholder="Twitter"
                            label="Twitter"
                            outlined
                            dense
                            v-model="formUpdate.TwitterShop"
                          ></v-text-field>
                        </v-row>
                      </v-col>
                      <v-col cols="6">
                        <v-row style="height: 65px">
                          <v-text-field
                            placeholder="Instagram"
                            label="Instagram"
                            outlined
                            dense
                            v-model="formUpdate.InstagramShop"
                          ></v-text-field>
                        </v-row>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="6">
                        <v-row style="height: 65px">
                          <v-text-field
                            placeholder="Youtube"
                            label="Youtube"
                            outlined
                            dense
                            v-model="formUpdate.YoutuberShop"
                          ></v-text-field>
                        </v-row>
                      </v-col>
                      <v-col cols="6">
                        <v-row style="height: 65px">
                          <v-text-field
                            placeholder="TikTok"
                            label="TikTok"
                            outlined
                            dense
                            v-model="formUpdate.TikTokShop"
                          ></v-text-field>
                        </v-row>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="6">
                        <v-row style="height: 65px">
                          <v-text-field
                            placeholder="แผนที่"
                            label="แผนที่"
                            outlined
                            dense
                            v-model="formUpdate.map"
                          ></v-text-field>
                        </v-row>
                      </v-col>
                      <v-col cols="6">
                        <v-row style="height: 50px">
                          <v-select
                            placeholder="ช่วงคะแนนหมดอายุ"
                            label="ช่วงคะแนนหมดอายุ"
                            outlined
                            dense
                            v-model="formUpdate.monthExpire"
                            :items="selectItem"
                            item-text="text"
                            item-value="value"
                          ></v-select>
                        </v-row>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="6">
                        <v-row style="height: 65px">
                          <v-select
                            placeholder="รอบตัดเหรียญหมดอายุ"
                            label="รอบตัดเหรียญหมดอายุ"
                            outlined
                            dense
                            v-model="formUpdate.expireMode"
                            :items="expireModeItems"
                            item-text="text"
                            item-value="value"
                          ></v-select>
                        </v-row>
                      </v-col>
                      <v-col cols="6" v-if="formUpdate.expireMode === 'dayOfMonth'">
                        <v-row style="height: 50px">
                          <v-select
                            placeholder="ตัดทุกวันที่"
                            label="ตัดทุกวันที่ (ของเดือน)"
                            outlined
                            dense
                            v-model="formUpdate.expireDay"
                            :items="expireDayItems"
                          ></v-select>
                        </v-row>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="6">
                        <v-row style="height: 65px">
                          <v-text-field
                            placeholder="รายละเอียดที่อยู่"
                            label="รายละเอียดที่อยู่"
                            outlined
                            dense
                            v-model="formUpdate.detailAddress"
                            :rules="[v => !!v || 'กรุณากรอกบ้านเลขที่']"
                          ></v-text-field>
                        </v-row>
                      </v-col>
                      <v-col cols="6">
                        <v-row style="height: 50px">
                          <v-text-field
                            placeholder="รหัสไปรษณีย์"
                            label="รหัสไปรษณีย์"
                            outlined
                            dense
                            v-model="formUpdate.postalCode"
                            :rules="[
                              v => !!v || 'กรุณากรอกรหัสไปรษณีย์',
                              v =>
                                (!isNaN(v) &&
                                  String(v).length >= 5 &&
                                  String(v).length <= 5) ||
                                'รหัสไปรษณีย์ต้องมีตัวเลข 5 ตัว'
                            ]"
                            @change="addAddress()"
                          ></v-text-field>
                        </v-row>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="6">
                        <v-row style="height: 65px">
                          <v-select
                            placeholder="ตำบล/แขวง"
                            label="ตำบล/แขวง"
                            outlined
                            dense
                            v-model="formUpdate.subDistrict"
                            :items="optionSubDistrict"
                            :rules="[v => !!v || 'กรุณากรอกตำบล']"
                          ></v-select>
                        </v-row>
                      </v-col>
                      <v-col cols="6">
                        <v-row style="height: 50px">
                          <v-select
                            placeholder="อำเภอ/เขต"
                            label="อำเภอ/เขต"
                            outlined
                            dense
                            v-model="formUpdate.district"
                            :items="optionDistrict"
                            :rules="[v => !!v || 'กรุณากรอกอำเภอ']"
                          ></v-select>
                        </v-row>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="6">
                        <v-row style="height: 65px">
                          <v-select
                            placeholder="จังหวัด"
                            label="จังหวัด"
                            outlined
                            dense
                            v-model="formUpdate.provinces"
                            :items="optionProvinces"
                            :rules="[v => !!v || 'กรุณากรอกจังหวัด']"
                          ></v-select>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-form>
              <v-card-actions>
                <v-col id="margin">
                  <v-row justify="center">
                    <v-btn
                      elevation="2"
                      x-large
                      color="#173053"
                      dark
                      :disabled="!validUpdate"
                      :loading="loadingEdit"
                      @click="editData()"
                    >
                      <v-icon left>mdi-checkbox-marked-circle</v-icon>
                      บันทึก
                    </v-btn>
                  </v-row>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- dialogLink -->
          <v-dialog v-model="dialogLink" max-width="40%">
            <v-card>
              <v-card-title>
                <span class="headline">ลิงค์สำหรับทำ List menu</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col class="text-center">
                      <v-row style="height: 60px">
                        <v-text-field
                          v-model="LinkPath"
                          placeholder="Copy Link"
                          ref="textToCopyformUpdate"
                          dense
                          outlined
                          readonly
                        ></v-text-field>
                        <v-col cols="1" xs="1" sm="1" md="1" lg="1">
                          <v-btn
                            color="primary"
                            fab
                            x-small
                            dark
                            @click="copyTextformUpdate"
                            ><v-icon>mdi-content-copy</v-icon></v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-col cols="12">
            <v-card elevation="7" v-if="dataReady">
              <v-card-title> </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItem"
                  :items-per-page="10"
                >
                  <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ format_dateNotime(item.CREATE_DATE) }}
                  </template>
                  <template v-slot:[`item.LAST_DATE`]="{ item }">
                    {{ format_dateNotime(item.LAST_DATE) }}
                  </template>
                  <template v-slot:[`item.expireDate`]="{ item }">
                    {{ format_dateNotime(item.expireDate) }}
                  </template>
                  <template v-slot:[`item.monthExpire`]="{ item }">
                    {{ item.monthExpire }}
                  </template>
                  <template v-slot:[`item.logo`]="{ item }">
                    <v-avatar color="primary" size="40">
                      <img :src="item.logo" alt="img"
                    /></v-avatar>
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          color="primary"
                          fab
                          x-small
                          @click.stop=";(dialogLink = true), Link()"
                        >
                          <v-icon dark> mdi-link </v-icon>
                        </v-btn>
                      </template>
                      <span>ลิ้งสำหรับ List Menu</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="btn-color"
                          fab
                          dark
                          x-small
                          @click.stop="
                            ;(dialogEdit = true),
                              getDataById(item),
                              validate('UPDATE')
                          "
                        >
                          <v-icon dark> mdi-tools </v-icon>
                        </v-btn>
                      </template>
                      <span>แก้ไขข้อมูล</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile
  },
  created () {
    setInterval(this.getNowGlobal, 1000)
  },
  data () {
    return {
      PK: '',
      path: '/only_shop/', // Path Model
      returnLink: '/system/EditShop',
      dataReady: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      code: 'SYS_GROUP_TYPE_', // Generate Code
      // Dialog Config ADD EDIT DELETE IMPORT
      dialogAdd: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogImport: false,
      dialogLink: false,
      // END Dialog Config ADD EDIT DELETE
      panel: [0],
      panel1: [1],
      session: this.$session.getAll(),
      formUpdate: {
        logo: '',
        logoPreview: '',
        contactTel: '',
        name: '',
        expireDate: '',
        Email: '',
        WebsiteShop: '',
        FacebookShop: '',
        LineShop: '',
        TwitterShop: '',
        InstagramShop: '',
        YoutuberShop: '',
        TikTokShop: '',
        map: '',
        pictureUrl: '',
        pictureUrlPreview: '',
        flexPicHomePage: '',
        flexPicHomePagePreview: '',
        flexPicMembercardPage: '',
        flexPicMembercardPagePreview: '',
        monthExpire: '12',
        expireMode: 'endOfMonth',
        expireDay: 1,
        postalCode: '',
        district: '',
        subDistrict: '',
        detailAddress: '',
        provinces: ''
      },
      selectItem: [
        { text: '3 เดือน', value: '3' },
        { text: '4 เดือน', value: '4' },
        { text: '1 ปี', value: '12' },
        { text: '2 ปี', value: '24' },
        { text: '3 ปี', value: '36' }
      ],
      expireModeItems: [
        { text: 'ตัดทุกวัน (ตามวันหมดอายุจริง)', value: 'daily' },
        { text: 'ตัดสิ้นเดือน', value: 'endOfMonth' },
        { text: 'ตัดทุกวันที่ (กำหนดเอง)', value: 'dayOfMonth' }
      ],
      expireDayItems: Array.from({ length: 31 }, (_, i) => i + 1),
      filesShop: null,
      flexPicHomePage: null,
      flexPicMembercardPage: null,
      filesUpdate: null,
      rules: {
        numberRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        counterTel: value => value.length <= 10 || 'Max 10 characters',
        IDcardRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        required: value => !!value || 'กรุณากรอก.',
        resizeImag: value =>
          !value ||
          value.size < 2000000 ||
          'Avatar size should be less than 2 MB!',
        counterIDcard: value => value.length <= 13 || 'Max 13 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      // End Form Config ADD EDIT
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'จัดการ ร้านค้า',
          disabled: true,
          href: '/System/EditShop'
        }
      ],
      // End Menu Config
      // Data Table Config
      columns: [
        { text: 'โลโก้', value: 'logo' },
        // { text: 'ID', value: 'shopId' },
        { text: 'ชื่อร้าน', value: 'name' },
        { text: 'เบอร์ร้าน', value: 'contactTel' },
        { text: 'E-mail', value: 'Email' },
        { text: 'Website', value: 'WebsiteShop' },
        { text: 'Facebook', value: 'FacebookShop' },
        { text: 'ช่วงคะแนนหมดอายุ', value: 'monthExpiredate' },
        { text: 'แผนที่', value: 'map' },
        { text: 'ที่อยุ่', value: 'Address' },
        // { text: 'วันที่หมดอายุ', value: 'expireDate' },
        { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
        { text: 'วันที่อัพเดท', value: 'LAST_DATE' },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'center' }
      ],
      dataItem: [],
      validUpdate: true,
      resZipCode: [],
      optionDistrict: [],
      optionSubDistrict: [],
      optionProvinces: [],
      loadingEdit: false,
      LinkPath: ''
      // End Data Table Config
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    // this.getGetToken(this.DNS_IP)
    // this.getDataTypeGroup()
    this.dataReady = false
    // Get Data
    await this.getDataGlobal(
      this.DNS_IP,
      this.path,
      this.session.data.shopId,
      this.returnLink
    )
    await this.setExpri()
    await this.addAddress()
  },
  methods: {
    copyTextformUpdate () {
      let textToCopyformUpdate = this.$refs.textToCopyformUpdate.$el.querySelector(
        'input'
      )
      textToCopyformUpdate.select()
      document.execCommand('copy')
    },
    Link () {
      this.LinkPath =
        'https://liff.line.me/1660987891-z3E1MKJ7/home?shopId=' +
        this.$session.getAll().data.shopId +
        '&type=welcome'
    },
    async setExpri () {
      console.log('data', this.dataItem)
      let month = this.dataItem
      this.dataItem = []
      for (let i = 0; i < month.length; i++) {
        let d = month[i]
        if (d.monthExpire !== '') {
          if (d.monthExpire === '12') {
            d.monthExpiredate = '1 ปี'
            console.log(d.monthExpiredate)
            this.dataItem.push(d)
          } else if (d.monthExpire === '24') {
            d.monthExpiredate = '2 ปี'
            this.dataItem.push(d)
            console.log(d.monthExpiredate)
          } else if (d.monthExpire === '36') {
            d.monthExpiredate = '3 ปี'
            this.dataItem.push(d)
            console.log(d.monthExpiredate)
          } else {
            d.monthExpiredate = d.monthExpire + ' เดือน'
            console.log(d.monthExpiredate)
            this.dataItem.push(d)
          }
        } else {
          d.packageExpridate = ''
          this.dataItem.push(d)
        }
      }
    },
    async addAddress () {
      const postalCode = String(this.formUpdate.postalCode || '')
      console.log('addAddress', postalCode)
      if (postalCode.length >= 5) {
        console.log('postalCode')
        this.optionDistrict = []
        this.optionSubDistrict = []
        this.optionProvinces = []
        await axios
          .get(
            // eslint-disable-next-line quotes
            'https://api.betaskthai.com/hrm/location/map_thai/?zipcode=' +
              postalCode
          )
          .then(async response => {
            console.log(response.data.length > 0)
            this.resZipCode = response.data
            console.log('this.resZipCode', this.resZipCode)
            let rs = response.data
            for (var i = 0; i < rs.length; i++) {
              var x = rs[i]
              var z = {}
              z.text = x.district
              z.value = x.district
              this.optionDistrict.push(z)

              var d = rs[i]
              var s = {}
              s.text = d.sub_district
              s.value = d.sub_district
              this.optionSubDistrict.push(s)
            }
            for (var t = 0; t < rs.length; t++) {
              var k = rs[t]
              var l = {}
              l.text = k.province
              l.value = k.province
              this.optionProvinces.push(l)
            }
          }) // eslint-disable-next-line handle-callback-err
          .catch(error => {
            console.log(error)
            // this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
          })
      }
      //   else if (this.formUpdate.postalCode.length < 5) {
      //     console.log('น้อยกว่า')
      //     this.optionDistrict = []
      //     this.optionSubDistrict = []
      //     this.optionProvinces = []
      //     this.formUpdate.postalCode = ''
      //     this.formUpdate.district = ''
      //     this.formUpdate.provinces = ''
      //   }
    },
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break

        default:
          break
      }
    },
    selectImgShop () {
      if (this.filesShop) {
        this.formUpdate.logoPreview = URL.createObjectURL(this.filesShop)
        console.log('ddddrrr', this.formUpdate.logoPreview)
      } else {
        this.formUpdate.logoPreview = ''
      }
    },
    selectImgUpdate (event) {
      if (this.filesUpdate != null) {
        this.formUpdate.pictureUrlPreview = URL.createObjectURL(
          this.filesUpdate
        )
      } else {
        this.formUpdate.pictureUrlPreview = ''
      }
    },
    selectImgHomePage (event) {
      if (this.flexPicHomePage != null) {
        this.formUpdate.flexPicHomePagePreview = URL.createObjectURL(
          this.flexPicHomePage
        )
      } else {
        this.formUpdate.flexPicHomePagePreview = ''
      }
    },
    selectImgMemberCard (event) {
      if (this.flexPicMembercardPage != null) {
        this.formUpdate.flexPicMembercardPagePreview = URL.createObjectURL(
          this.flexPicMembercardPage
        )
      } else {
        this.formUpdate.flexPicMembercardPagePreview = ''
      }
    },
    async getDataById (item) {
      //
      //
      // สำหรับ เรียกข้อมูล ใส่ form Update / Delete
      //
      //
      // Get ID /main.js
      this.dataReady = false
      await this.getDataByIdGlobal(
        this.DNS_IP,
        this.path,
        'shopId',
        item.shopId,
        this.returnLink
      )
      this.formUpdate.monthExpire = this.formUpdate.monthExpire
      console.log('monthExp', this.formUpdate.monthExpire)
      try {
        const sched = await axios.get(this.DNS_IP + '/system_shop/expire-schedule/' + item.shopId)
        if (sched.data && sched.data.status) {
          this.formUpdate.expireMode = sched.data.expireMode || 'endOfMonth'
          this.formUpdate.expireDay = sched.data.expireDay || 1
        }
      } catch (e) {
        console.log('expire-schedule load error', e)
      }
      //   this.formUpdate.monthExpire = item.text
      this.formUpdate.logoPreview = this.formUpdate.logo
      this.formUpdate.pictureUrlPreview = this.formUpdate.pictureUrl
      this.formUpdate.flexPicHomePagePreview = this.formUpdate.flexPicHomePage
      this.formUpdate.flexPicMembercardPagePreview = this.formUpdate.flexPicMembercardPage
      this.formUpdate.expireDate = moment(this.formUpdate.expireDate).format(
        'YYYY-MM-DD HH:mm'
      )
      await this.addAddress()
      this.validate('UPDATE')
    //   this.formUpdate.postalCode = parseInt(this.formUpdate.postalCode)
    //   console.log('int', typeof this.formUpdate.postalCode);
    },
    async editData () {
      // this.editDataGlobal(this.DNS_IP, this.path, this.PK, this.formUpdateItem)
      this.dataReady = false

      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.loadingEdit = true
          this.formUpdate.LAST_USER = this.session.data.userName
          var ID = this.formUpdate.shopId
          if (this.filesShop) {
            const _this = this
            let params = new FormData()
            params.append('file', this.filesShop)

            await axios
              .post(this.DNS_IP + `/file/upload/reward`, params)
              .then(function (response) {
                _this.formUpdate.logo = response.data
                console.log('url Pic', response.data)
              })
          } else {
            this.formUpdate.logo = this.formUpdate.logoPreview
          }
          if (this.filesUpdate) {
            const _this = this
            let params = new FormData()
            params.append('file', this.filesUpdate)

            await axios
              .post(this.DNS_IP + `/file/upload/reward`, params)
              .then(function (response) {
                _this.formUpdate.pictureUrl = response.data
                console.log('url Pic', response.data)
              })
          } else {
            this.formUpdate.pictureUrl = this.formUpdate.pictureUrlPreview
          }
          if (this.flexPicHomePage) {
            const _this = this
            let params = new FormData()
            params.append('file', this.flexPicHomePage)

            await axios
              .post(this.DNS_IP + `/file/upload/reward`, params)
              .then(function (response) {
                _this.formUpdate.flexPicHomePage = response.data
                console.log('url Pic', response.data)
              })
          } else {
            this.formUpdate.flexPicHomePage = this.formUpdate.flexPicHomePagelPreview
          }
          if (this.flexPicMembercardPage) {
            const _this = this
            let params = new FormData()
            params.append('file', this.flexPicMembercardPage)

            await axios
              .post(this.DNS_IP + `/file/upload/reward`, params)
              .then(function (response) {
                _this.formUpdate.flexPicMembercardPage = response.data
                console.log('url Pic', response.data)
              })
          } else {
            this.formUpdate.flexPicMembercardPage = this.formUpdate.flexPicMembercardPagePreview
          }
          delete this.formUpdate['pictureUrlPreview']
          delete this.formUpdate['logoPreview']
          delete this.formUpdate['shopId']
          delete this.formUpdate['LAST_DATE']
          delete this.formUpdate['CREATE_DATE']
          delete this.formUpdate['expireDate']
          delete this.formUpdate['flexPicMembercardPagePreview']
          delete this.formUpdate['flexPicHomePagePreview']
          console.log('this.formUpdate', this.formUpdate)
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + 'edit/' + ID,
              this.formUpdate
              // {
              //   headers: {
              //     'Application-Key': this.$session.getAll().ApplicationKey
              //   }
              // }
            )
            .then(async response => {
              // Debug response
              console.log('editDataGlobal DNS_IP + PATH + "edit"', response)

              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              this.dialogEdit = false

              // Load Data
              // await this.reloadData()
              await this.clearDataUpdate()
              this.filesShop = null
              this.filesUpdate = null
              this.flexPicHomePage = null
              this.flexPicMembercardPage = null
              await this.getDataGlobal(
                this.DNS_IP,
                this.path,
                this.session.data.shopId,
                this.returnLink
              )
              await this.setExpri()
              this.loadingEdit = false
            })
            // eslint-disable-next-line handle-callback-err
            .catch(error => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
            })
        })
        .catch(error => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async clearDataUpdate () {
      // eslint-disable-next-line no-redeclare
      for (var key in this.formUpdate) {
        if (this.formUpdate[key]) {
          this.formUpdate[key] = ''
        }
      }
    }
  }
}
</script>
<style scope></style>



// WEBPACK FOOTER //
// src/components/System/EditShop.vue